var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyOutlinedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.997,
    height: 24,
    viewBox: "0 0 23.997 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_6554",
    "data-name": "Rettangolo 6554",
    width: 23.997,
    height: 24,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_18157",
    "data-name": "Raggruppa 18157",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_18156",
    "data-name": "Raggruppa 18156",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_22409",
    "data-name": "Tracciato 22409",
    d: "M21.178.375H7.724A2.512,2.512,0,0,0,5.065,3.039c0,.666,0,1.332,0,2.026-.728,0-1.419,0-2.111,0A2.5,2.5,0,0,0,.377,7.639q-.005,6.8,0,13.6a2.5,2.5,0,0,0,2.57,2.582q6.812.005,13.625,0a2.5,2.5,0,0,0,2.56-2.566c0-.627,0-1.253,0-1.88v-.242H21.17a2.512,2.512,0,0,0,2.651-2.648q0-6.727,0-13.455A2.512,2.512,0,0,0,21.178.375M17.569,21.2a.951.951,0,0,1-1.052,1.06H3.017a.959.959,0,0,1-1.078-1.082V7.7A.954.954,0,0,1,3,6.628H16.5A.956.956,0,0,1,17.569,7.7q0,6.75,0,13.5m4.689-4.723a.964.964,0,0,1-1.092,1.094l-1.954,0a.536.536,0,0,1-.081-.018v-.273q0-4.825,0-9.648a2.484,2.484,0,0,0-1.913-2.484,3.205,3.205,0,0,0-.749-.076q-4.762-.008-9.525,0H6.63c0-.776-.012-1.516,0-2.256A.918.918,0,0,1,7.5,1.941c.073-.005.146,0,.219,0H21.154a.966.966,0,0,1,1.1,1.106V16.476",
    transform: "translate(-0.1 -0.1)",
    fill: "#a5a9c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_22410",
    "data-name": "Tracciato 22410",
    d: "M21.178.375H7.724A2.512,2.512,0,0,0,5.065,3.039c0,.666,0,1.332,0,2.026-.728,0-1.419,0-2.111,0A2.5,2.5,0,0,0,.377,7.639q-.005,6.8,0,13.6a2.5,2.5,0,0,0,2.57,2.582q6.812.005,13.625,0a2.5,2.5,0,0,0,2.56-2.566c0-.627,0-1.253,0-1.88v-.242H21.17a2.512,2.512,0,0,0,2.651-2.648q0-6.727,0-13.455A2.512,2.512,0,0,0,21.178.375ZM17.569,21.2a.951.951,0,0,1-1.052,1.06H3.017a.959.959,0,0,1-1.078-1.082V7.7A.954.954,0,0,1,3,6.628H16.5A.956.956,0,0,1,17.569,7.7Q17.57,14.448,17.569,21.2Zm4.689-4.723a.964.964,0,0,1-1.092,1.094l-1.954,0a.536.536,0,0,1-.081-.018v-.273q0-4.825,0-9.648a2.484,2.484,0,0,0-1.913-2.484,3.205,3.205,0,0,0-.749-.076q-4.762-.008-9.525,0H6.63c0-.776-.012-1.516,0-2.256A.918.918,0,0,1,7.5,1.941c.073-.005.146,0,.219,0H21.154a.966.966,0,0,1,1.1,1.106Z",
    transform: "translate(-0.1 -0.1)",
    fill: "none",
    stroke: "#a5a9c7",
    strokeWidth: 0.75
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyOutlinedIcon);
export default __webpack_public_path__ + "static/media/copy-outlined-icon.d473ffc7.svg";
export { ForwardRef as ReactComponent };